<script>
export default {
  name: 'Rainbow',
  props: ['thickness'],
  computed: {
    colors() {
      return ['#8CC640', '#F7971D', '#EF5334', '#E2C520', '#0AABCA', '#008098']
    },
  },
}
</script>

<template>
<v-container>
  <v-row justify-content="start" class="flex-nowrap">
    <v-col v-for="color in colors" :key="color" :style="{ borderBottom: `solid ${ thickness || '2px'} ${ color }` }"></v-col>
  </v-row>
</v-container>
</template>
